export default "__VITE_ASSET__DHaTUkjD__"